module.exports = __webpack_public_path__ + "static/media/intro.dbb7c6f5.mp3";